import React from "react";
import { Slider } from "./ui/slider";

const STEPS = [
  { value: "NM", label: "Near Mint", color: "#A78BFA" },
  { value: "LP", label: "Lightly Played", color: "#7C3AED" },
  { value: "MP", label: "Moderately Played", color: "#F59E0B" },
  { value: "HP", label: "Heavily Played", color: "#f97316" },
  { value: "DMG", label: "Damaged", color: "#EF4444" },
];

export default function ConditionSlider({ condition, onChange }) {
  const index = Math.max(0, STEPS.findIndex((s) => s.value === condition));
  const current = STEPS[index] || STEPS[0];

  return (
    <div data-testid="condition-slider-wrapper" className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-zinc-500">Condition</span>
        <span
          data-testid="condition-slider-label"
          className="text-sm font-semibold px-2.5 py-0.5 rounded-full border"
          style={{ color: current.color, borderColor: `${current.color}55`, background: `${current.color}15` }}
        >
          {current.label}
        </span>
      </div>
      <Slider
        data-testid="condition-slider"
        min={0}
        max={4}
        step={1}
        value={[index]}
        onValueChange={(v) => onChange(STEPS[v[0]].value)}
        className="py-2 cursor-pointer [&_[data-orientation]]:bg-white/10 [&_[data-orientation]]:h-2 [&_[role=slider]]:h-6 [&_[role=slider]]:w-6 [&_[role=slider]]:cursor-grab [&_[role=slider]]:active:cursor-grabbing [&_[role=slider]]:transition-transform [&_[role=slider]]:hover:scale-110 [&_[role=slider]]:active:scale-95"
      />
      <div className="flex justify-between text-[10px] text-zinc-500 font-mono-plex">
        {STEPS.map((s, i) => (
          <button
            key={s.value}
            type="button"
            data-testid={`condition-slider-step-${s.value}`}
            onClick={() => onChange(s.value)}
            className={`px-1.5 py-0.5 rounded transition-colors hover:text-white ${i === index ? "text-white font-semibold" : ""}`}
          >
            {s.value}
          </button>
        ))}
      </div>
    </div>
  );
}
